import "./EditMemberEmailModal.scss";
import { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { MemberDto, UpdateMemberDto } from "../../../generated/dashboard-client";
import { success } from "../../../service/MessageService";
import AccountMembersApi from "../../../api/AccountMembersApi";

export type MemberFieldType = "no" | "email" | "password" | "name";

export interface EditMemberEmailModalProps {
  visible: boolean;
  value: string;
  type: MemberFieldType;
  member: MemberDto;
  onCancel: () => void;
  onDone: (type: MemberFieldType, value: string) => void;
}

const emailRgx =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function EditMemberEmailModal({
  member,
  value,
  type,
  visible,
  onCancel,
  onDone,
}: EditMemberEmailModalProps) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    setEmail(value);
    setEmailError("");
    setPassword("");
    setPasswordError("");
    setLoading(false);
  }, [value, visible]);

  function onSave() {
    const dto = {} as UpdateMemberDto;
    dto.email = email;
    dto.currentPassword = password;

    if (!emailRgx.test(String(email).toLowerCase())) {
      setEmailError("Invalid email");
      return;
    }

    if (!password) {
      setPasswordError("Invalid password");
      return;
    }

    setLoading(true);
    AccountMembersApi.updateMember(member.id || "", dto)
      .then((resp) => {
        success("Successfully updated!");
        onDone(type, value);
      })
      .catch((e) => {
        setLoading(false);
        if (e.response) {
          setPasswordError(!!e.response ? e.response.data.message : e.response);
        }
      });
  }

  return (
    <Modal
      className={"edit-member-modal clean one"}
      visible={visible}
      closable={false}
    >
      <header>
        <h2>Edit Email Login</h2>
      </header>

      <label>Email Address</label>
      <input
        className={"lg"}
        value={email}
        type={"email"}
        onChange={(ev) => {
          setEmail(ev.target.value);
          setEmailError("");
        }}
      />
      {emailError && <span className={"error"}>{emailError}</span>}

      <label>Password</label>
      <input
        className={passwordError ? "lg error" : "lg"}
        value={password}
        placeholder={"Confirm your password"}
        type={"password"}
        onChange={(ev) => {
          setPassword(ev.target.value);
          setPasswordError("");
        }}
      />
      {passwordError && <span className={"error"}>{passwordError}</span>}

      <footer>
        <Button 
          className={"cancel"} 
          size={"large"}
          onClick={onCancel}
        >
          <span>Cancel</span>
        </Button>
        <Button
          className={"primary"}
          size={"large"}
          disabled={!value}
          loading={loading}
          onClick={onSave}
        >
          <span>Save</span>
        </Button>
      </footer>
    </Modal>
  );
}
